import {Component} from "@angular/core";
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {FormComponent} from "../renderer/model/form-component";
import {SESSION_COMPONENT} from "../renderer/model/dictionary";
import {AbstractEditorComponent} from "./abstract.editor.component";
import {hasChildren} from "../renderer/model/form-component-utils";

export class TreeNode extends FormComponent { //matches the structure of FormComponent
    level?: number;
}

@Component({
    selector: "tree-editor",
    templateUrl: './tree.editor.component.html',
    styleUrls: ['./tree.editor.component.css'],
})
export class TreeEditorComponent extends AbstractEditorComponent {

    hasChildren(node: TreeNode): boolean {
        return hasChildren(node); //!!node.components && node.components && node.components.length > 0;
    }

    treeControl = new FlatTreeControl<TreeNode>(
        node => node.level, node => this.hasChildren(node));

    private _transformer = (node: TreeNode, level: number) => {
        return {
            id: node.id,
            type: node.type,
            level: level,
            label: node.label,
            components: node.components,
            validators: node.validators,
            options: node.options,
            expandable: this.hasChildren(node),
        };
    };

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        node => node.level,
        node => node.expandable,
        node => node.components);

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    ngOnInit(): void {
        super.ngOnInit();

        const jsonComponent = sessionStorage.getItem(SESSION_COMPONENT);
        const component: FormComponent = JSON.parse(jsonComponent);

        console.log('Load tree');
        console.log(component);

        this.dataSource.data = Array.of(component);
        this.treeControl.expandAll();
    }

    hasChild = (_: number, node: TreeNode) => this.hasChildren(node);

    getShortVersion(node: TreeNode): string {
        if (node.label && node.label.length > 32) {
            return node.label.substr(0, 32) + '..';
        }
        if (!node.label || node.label.length == 0) {
            if (node.id && node.id.length > 32) {
                return 'id:'+node.id.substr(0, 32) + '..';
            }
            return 'id:'+node.id;
        }
        return node.label;
    }

}
